export default __webpack_public_path__ + "static/media/basic.a5e09793.jpg";